// eslint-disable-next-line @typescript-eslint/no-explicit-any
export class BBJEvent<Args extends any[], Func extends (...args: Args) => void = (...args: Args) => void> {
  private callbacks: Func[];

  constructor() {
    this.callbacks = [];
  }

  register(callback: Func) {
    this.callbacks.push(callback);
    return callback;
  }

  unregister(callback: Func) {
    const index = this.callbacks.findIndex((v) => v === callback);
    if (index !== -1) {
      this.callbacks.splice(index, 1);
    }
  }

  invoke(...args: Args) {
    for (const callback of this.callbacks) {
      callback(...args);
    }
  }
}
